import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import { API_LIQUIDATION_BANK_CODES } from "../../utils/apis";
import {
  createColumn,
  createViewAction,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_LIQUIDATION_BANK_CODES } from "../../utils/urls";

export const useLiquidationBankCodes = () => {
  const tableColumns = () => [
    createColumn("created_by", true, "Created By"),
    createColumn("bank_name", true, "Bank Name"),
    createColumn("bank_code", true, "Bank Code"),
    createColumn("is_active", true, "Is Active"),
    createColumn("created_at", true, "Created At"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => {
    return data?.map((item: any) => {
      return {
        ...item,
        created_by:
          item?.created_by?.first_name + " " + item?.created_by?.last_name,
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDateTime(item?.created_at),

        actions: (
          <FormActions
            actions={[createViewAction(URL_LIQUIDATION_BANK_CODES, item?.id)]}
          />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Liquidation Bank Code Details",
          fields: {
            bank_name: item?.bank_name,
            bank_code: item?.bank_code,
            is_active: <BooleanTags status={item?.is_active} />,
            deleted: <BooleanTags status={item?.deleted} />,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(URL_LIQUIDATION_BANK_CODES);

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
  };
};

export const useLiquidationBankCodesForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Liquidation Bank Code",
      fields: [
        {
          field_name: "bank_name",
          label: "Bank Name",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "bank_code",
          label: "Bank Code",
          type: "text",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_LIQUIDATION_BANK_CODES);

  return {
    sections,
    redirect,
  };
};

export const submitLiquidationBankCodes = (payload: any, id: string) => {
  if (id) {
    return {
      id,
      api: API_LIQUIDATION_BANK_CODES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_LIQUIDATION_BANK_CODES,
    params: {
      ...payload,
    },
  };
};
